import create from 'zustand';
import produce from 'immer';

const EXAM_STUDENT_INITIAL = {
	take: {
		id: 0,
		state: '',
		score: 0,
		mark: 0,
		startDate: '',
		endDate: '',
		startedAt: '',
		endedAt: ''
	},

	exam: {
		id: 0,
		slug: '',
		duration: 0,
		titlePublic: '',
		description: ''
	},

	subject: {
		id: 0,
		title: ''
	},

	student: {
		slug: ''
	},

	tasks: [],

	answers: [],

	summaries: []
};

export const useExamStudentStore = create(set => ({
	...EXAM_STUDENT_INITIAL,

	// Update take's started date and state
	onStart: (data) => set((state) => ({
		take: {
			...state.take,
			state: data.state,
			startedAt: data.startedAt
		},

		tasks: data.tasks,

		answers: data.answers
	})),

	// Update take's ended date and state
	onEnd: (data) => set((state) => ({
		take: {
			...state.take,
			state: data.state,
			endedAt: data.endedAt
		}
	})),

	// Handle answer change
	onChange: (id, { name, value }) => set(produce((state) => {
		const answer = state.answers.find(a => a.id === id);
		answer[name] = value;
	})),

	// Handle answer option change
	onChangeOption: (id, optionId, { name, value }) => set(produce(state => {
		const answer = state.answers.find(a => a.id === id);
		const option = answer.options.find(o => o.id === optionId);
		option[name] = value;
	})),

	// Handle answer word change
	onChangeWord: (id, { name, value }) => set(produce(state => {
		const answer = state.answers.find(a => a.id === id);
		const word = answer.words.find(w => w.key === name);
		word.answer = value;
	})),

	// Handle file addition
	onFileAdd: (id, files) => set(produce(state => {
		const answer = state.answers.find(a => a.id === id);
		answer.files = [...answer.files, ...files];
	})),

	// Handle file removal
	onFileRemove: (id, fileId) => set(produce(state => {
		const answer = state.answers.find(a => a.id === id);
		answer.files = answer.files.filter(file => file.id !== fileId);
	})),

	// Initialize exam's state
	onInit: (take) => set((state) => ({
		take: {
			id: take.id,
			state: take.state,
			score: take.score,
			mark: take.mark,
			startDate: take.startDate,
			endDate: take.endDate,
			startedAt: take.startedAt,
			endedAt: take.endedAt
		},

		exam: take?.exam ? {
			id: take.exam?.id,
			slug: take.exam?.slug,
			duration: take.exam?.duration,
			titlePublic: take.exam?.titlePublic,
			description: take.exam?.description
		}	: {
			...state.exam
		},

		subject: take?.exam?.subject ? {
			id: take.exam.subject?.id,
			title: take.exam.subject?.title
		} : {
			...state.subject
		},

		student: take?.student ? {
			slug: take?.student?.slug
		} : {
			...state.student
		},

		tasks: take?.exam?.tasks,

		answers: take?.answers,

		summaries: take?.summaries
	})),

	// Reset store to initial state
	onReset: () => set({
		...EXAM_STUDENT_INITIAL
	})
}));